import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ImpersonateService } from './impersonate.service';
import { ImpersonateInterceptor } from './impersonate.interceptor';

@NgModule({
  providers: [
    ImpersonateService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ImpersonateInterceptor,
      multi: true,
    },
  ],
})
export class ImpersonateModule {}
